declare var $: any;
import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Field, SiteSettingFacade, LanguageModel, ResourceFacade, DataParser } from '../../services';
import { ControlContainer, FormGroupDirective, FormGroup } from '@angular/forms';
import { FieldTool } from './tools/fields.tool';
import { EFieldType } from './tools/field-type.enum';
import { BaseComponent } from "../../base/base-component.component";
import { TranslateService } from '@ngx-translate/core';
import { IDropdownSettings, MultiSelectComponent } from 'ng-multiselect-dropdown';
import { Observable, of } from 'rxjs';
import { StringTool } from "../../tools/index";


@Component({
  selector: 'field-control',
  templateUrl: './field-control.component.html',
  styleUrls: ['./field-control.component.css'],

  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FieldControlComponent extends BaseComponent implements OnInit {

  @Input() schemaName: string;
  @Input() field: Field;
  @Input() value: any;
  @Input() referenceValues: any;
  @Input() monacoLanguage: string;
  @Input() form: FormGroup;

  @Input()
  uniqueFieldControlId: string;

  @Output() imageEmitter = new EventEmitter<any>();
  @Output() deleteAssetEmitter = new EventEmitter<any>();
  @Output() newAssetEmitter = new EventEmitter<any>();
  @Output() updateFormControl = new EventEmitter<any>();


  eFieldType = EFieldType;
  fieldType: EFieldType;
  languages: LanguageModel[];
  isLocalize: boolean;
  currentLanguage: string;
  placeholder = {};
  label = '';
  referenceItems: any = [];
  referenceInitObs$: Observable<any>;

  private dataParser: DataParser;
  languageCustomClass = 'language-nav-tabs';

  dropdownSettings: IDropdownSettings;
  ckEditorConfig: any;

  @ViewChild('currentElement', null) currentElement;

  constructor(
    translateService: TranslateService,
    private readonly siteSettingFacade: SiteSettingFacade,
    private readonly resourceFacade: ResourceFacade) {
    super(translateService);
    this.setCkEditorConfig();
  }

  ngOnInit(): void {

    if (!this.uniqueFieldControlId) {
      const guidRegEx = (new StringTool()).generateGuid();
      this.uniqueFieldControlId = guidRegEx;
    }

    this.initLabel();
    this.initLanguages();
    this.initType();
    this.referenceInitObs$ = of(this.initReferenceItem());
    this.initCurrentLanguage();
    this.initPlaceholder();
    this.initIsLocalized();
    this.initDropdown();



  }

  setCkEditorConfig(): void {
    this.ckEditorConfig = {
      autoParagraph: false,
      ignoreEmptyParagraph: true,
      allowedContent: true,
      fillEmptyBlocks: false,
      extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*)[*]{*};',
      // CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
      height: 500,
      toolbarGroups: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
        { name: 'forms', groups: ['forms'] },
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'tools', groups: ['tools'] },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        '/',
        { name: 'others', groups: ['others'] },
      ],
      removeButtons:
        'Save,NewPage,Print,Paste,PasteText,PasteFromWord,Scayt,Form,Radio,Checkbox,TextField,Textarea,Select,Button,ImageButton,HiddenField',
      removePlugins: 'htmldataprocessor',
      protectedSource: [/{{[\s\S]*?}}/g],
      extraPlugins: 'colorbutton,colordialog',
    };
  }

  initDropdown() {
    this.dropdownSettings = {
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      singleSelection: this.fieldType === this.eFieldType.SELECT
    };
  }

  initLabel() {
    this.resourceFacade.getByCode(`${this.schemaName}.${this.field.name}.label`).subscribe(result => {
      if (result) {
        this.label = result.data.value[this.resourceFacade.getCurrentLanguage()];
      } else {
        if (this.field.properties.label) {
          this.label = this.field.properties.label;
        } else {
          this.ts(this.field.name.toUpperCase(), this.schemaName).subscribe(val => {
            this.label = val.toString();
          });
        }
      }
    });
  }

  initPlaceholder() {
    this.resourceFacade.getByCode(`${this.schemaName}.${this.field.name}.placeholder`).subscribe(result => {
      if (result) {
        this.placeholder = result.data.value;
      } else {
        this.placeholder = this.field.properties.placeholder;
      }
    });
  }

  initIsLocalized() {
    this.isLocalize = this.field.partitioning === 'language';
  }

  initType() {
    this.fieldType = FieldTool.getTypeFromField(this.field);
    if (this.field.properties.allowedValues)
      this.referenceValues = this.field.properties.allowedValues;
  }

  initReferenceItem(): boolean {

    if (this.fieldType !== this.eFieldType.SELECT_MULTIPLE &&
      this.fieldType !== this.eFieldType.ORDONNABLE_SELECT_MULTIPLE &&
      this.fieldType !== this.eFieldType.SELECT
    ) {
      return false;
    }

    if (!this.referenceValues) {
      console.log('no values for multiselect');
      return false;
    }

    this.referenceItems = [];

    if (this.referenceValues && this.referenceValues.length > 0) {
      for (let i = 0; i < this.referenceValues.length; i++) {
        let item = this.referenceValues[i];
        this.referenceItems.push({
          item_id: item.Id ?? item,
          item_text: item.Label ?? item
        });
      }
    }

    if (this.value && Object.keys(this.value).length > 0) {
      let initialItem = [];
      for (let i = 0; i < this.value.iv.length; i++) {
        let itm = this.referenceItems.find(v => v.item_id === this.value.iv[i]);

        if (itm) {
          initialItem.push(itm);
        }
      }
      this.form.get(this.field.name).setValue(initialItem);
    }
    return true;
  }

  selectReferenceFieldValue(items: any) {
    if (!items) {
      return;
    }

    const initialItem = [];
    for (let i = 0; i < items.length; i++) {
      const vv = items[i];
      const itm = this.referenceItems.find(v => v.item_id === vv.item_id);
      if (itm) {
        return;
      }
      this.referenceItems.push(vv);
      initialItem.push(vv);
    }

    if (initialItem.length <= 0) {
      return;
    }

    this.form.get(this.field.name).setValue(initialItem);
  }

  initLanguages() {
    this.siteSettingFacade.getSiteLanguages().subscribe(languages => {
      if (languages.length <= 1) {
        this.languageCustomClass = 'hide-nav-tabs';
      }
      this.languages = languages;
      this.dataParser = new DataParser(this.languages);
    });
  }

  getDateObj(language: string): Date {
    if (!this.value || !this.value[language]) {
      return null;
    }

    return new Date(this.value[language]);
  }

  initCurrentLanguage() {
    this.currentLanguage = this.siteSettingFacade.getCurrentLanguage();
  }

  changeLanguage(event, langCode) {
    if (langCode !== '') {
      this.dataParser.changeLanguage(langCode);
    }
    $(event.currentTarget).parent().parent().find('li').removeClass('active');
    $(event.currentTarget).parent().addClass('active');
  }

  assetLoaded(file: any) {
    const input = document.getElementById(this.field.name);
    input.setAttribute('value', file.id);
    this.form.controls[this.field.name].setValue([file.id]);
  }

  newAsset(file: any) {
    this.imageEmitter.emit(file);
  }

  deleteAsset(file: any) {
    this.deleteAssetEmitter.emit(file);
  }

  ordMultiSelectDrop(event) {
    let clone = this.clone(this.value.iv);
    let newValues = this.moveArray(clone, event['previousIndex'], event['currentIndex']);
    this.updateFormControl.emit({ field: this.field.name, values: newValues });
  }

  moveArray(array: any[], from: number, to: number): any[] {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
  }
}
